<div class="login-container">
    <div class="login-background">
        <div class="shape"></div>
        <div class="shape"></div>
    </div>
    <div class="login-content">
        <div class="logo-container">
            <img src="assets/images/nri-logo-white.png" alt="logo" class="logo pulse">
        </div>
        
        <div class="login-card">
            <div class="login-header">
                <h2>Welcome Back</h2>
                <p>Please login to continue</p>
            </div>
            
            <form [formGroup]="signinForm" (ngSubmit)="signIn()">
                <div class="form-group">
                    <app-text-input 
                        label="Email Address" 
                        placeholder=" " 
                        [control]="getControl('email')">
                    </app-text-input>
                </div>
                
                <div class="form-group password-group">
                    <app-text-input 
                        label="Password" 
                        placeholder=" " 
                        [type]="isPasswordVisible ? 'text' : 'password'" 
                        [control]="getControl('password')">
                    </app-text-input>
                    <i class="fa toggle-password" 
                       [ngClass]="isPasswordVisible ? 'fa-eye' : 'fa-eye-slash'" 
                       (click)="togglePasswordVisibility()">
                    </i>
                </div>
                
                <button type="submit" class="login-btn btn-primary" [disabled]="loading">
                    <span *ngIf="!loading">Sign In</span>
                    <div *ngIf="loading" class="spinner"></div>
                </button>
                
                <div class="forgot-password">
                    <a [routerLink]="['/forgot-password']" class="forgot-link">Forgot Password?</a>
                </div>
            </form>
            <div class="dont-account">
                <p>Don't have an account? <a [routerLink]="['/nri-signup']">Sign Up</a></p>
            </div>
        </div>
    </div>
</div>

